import { getEnvironmentalVariables } from './env-service';

const env = getEnvironmentalVariables();

function getTransportBaseUrl(siteId: string) {
  switch (env.MAD_API_ENV) {
    case 'development':
      return `https://transport-dev.ingrid.com/s/${siteId}`;
    case 'stage':
      return `https://transport-stg.ingrid.com/s/${siteId}`;
    case 'production':
      return `https://transport.ingrid.com/s/${siteId}`;
  }
}

export function getTransportUrl(siteId: string, path: `/${string}`) {
  return `${getTransportBaseUrl(siteId)}${path}`;
}
